import { defineStore } from 'pinia'
import { rankingFilters, rankingOptionI, rankingRegions, rankingTypes, worldTypes } from '@/config/rankings'
import { computed } from 'vue'
import { useRoute } from 'vue-router'

function getFilterByKey(filterKey: string) {
  if (!filterKey) return undefined // default
  const key = filterKey.toLowerCase()
  return (
    rankingFilters.find((x) => x.key === key) ||
    rankingFilters
      .reduce(
        (prev, cur) => (cur.key !== 'job' && cur.children ? prev.concat(cur.children) : prev),
        [] as rankingOptionI[]
      )
      .find((x) => x.key === key)
  )
}

export const useRankingOptionsStore = defineStore('RankingOptionsStore', () => {
  const route = useRoute()

  const rankingRegion = computed(() => rankingRegions.find((x) => x.key === route.params.region?.toString()))
  const rankingType = computed(() =>
    rankingTypes.find((x) => x.key === route.params.type?.toString().replace('-ranking', ''))
  )

  const rankingFilter = computed(() => getFilterByKey(route.params.filter?.toString() ?? ''))

  const rankingJobs = computed(
    () =>
      rankingFilters.find((x) => x.key === 'job')?.children?.filter((c) => c.filter === rankingFilter.value?.key) ?? []
  )

  const rankingJob = computed(() =>
    rankingFilters.find((x) => x.key === 'job')?.children?.find((x) => x.key === route.params.filter2?.toString())
  )
  const rankingWorldType = computed(() => worldTypes.find((x) => x.key === route.query.world_type?.toString()))
  const pageIndex = computed(() => Number(route.query.page_index?.toString() ?? '1'))

  const disabledWorldType = computed<boolean>(
    () =>
      ['achievenment', 'legion', 'world'].includes(rankingType.value?.key ?? '') ||
      !rankingFilter.value ||
      (rankingFilter.value.kind === 'faction' && !rankingJob.value) ||
      ['classic'].includes(rankingFilter.value.key)
  )

  const optionSelectionComplete = computed<boolean>(
    () =>
      rankingType.value?.key === 'achievement' ||
      (!!rankingFilter.value &&
        (rankingFilter.value?.kind !== 'faction' || !!rankingJob.value) &&
        (disabledWorldType.value || !!rankingWorldType.value))
  )

  const searchKeyword = computed(() => route.query.search?.toString() ?? '')
  const searchType = computed(() => (route.query.search_type?.toString() === 'ranks' ? 'ranks' : 'character-name'))

  return {
    rankingRegion,
    rankingType,
    rankingFilter,
    rankingJobs,
    rankingJob,
    rankingWorldType,
    pageIndex,
    disabledWorldType,
    optionSelectionComplete,
    searchKeyword,
    searchType,
  }
})
